<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div ref="userDocsTab">
    <uploader-sidebar :isSidebarActive="sidebarActive" :studentId="studentId" @saveData="successUpload" @closeSidebar="sidebarActive = false" />
    <div class="vx-col w-full">
      <vs-button color="success" type="filled" class="mb-2" @click="sidebarActive = true">Upload Document</vs-button>
      <div>
        <vs-table
                  ref="uploadsTable"
                  stripe
                  class="vs-con-loading__container"
                  single
                  max-items="5"
                  @selected="open"
                  pagination
                  :data="uploadedFiles"
                  search>
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th sort-key="url">File Name</vs-th>
            <vs-th sort-key="moduleName">Type</vs-th>
            <vs-th sort-key="moduleName">Linked Module</vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
              <vs-td>
                <img :src="setFileThumb(file.url)" width=30px class="product-img" />
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.url.substring(file.url.lastIndexOf('/') + 1) }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.documentTypeName ? file.documentTypeName : "None" }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.moduleName ? file.moduleName : "None" }}</p>
              </vs-td>
              <vs-td style="width: 275px;">
                <span class="flex" v-if="file.documentTypeId == 4 && !file.accepted">
                  <vs-button class="mr-3" color="success" type="filled" icon-pack="feather" icon="icon-check" @click.stop.prevent="accept(file.id)">Accept</vs-button>
                </span>
              </vs-td>
              <vs-td class="float-right">
                <vs-button v-if="file.documentTypeId != 9"  color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop.prevent="removeDoc(file.id)"></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <vs-popup id="feedbackprompt" title="Feedback" :active.sync="acceptPrompt">
      <div id="popup-content-area">
        <div class="vx-row mb-4" v-for="(question, index) in assessmentQuestions" :key="index">
          <div class="vx-col w-full">
            <h5><strong>{{question.text}}</strong></h5>
            <div class="vx-row mt-3" style="text-align: center;">
              <div class="vx-col w-1/2">
                <p-radio class="p-round p-fill p-smooth p-bigger" color="success" v-model="question.answer" :value="true" :name="`radio-${index}`">Yes</p-radio>
              </div>
              <div class="vx-col w-1/2">
                <p-radio class="p-round p-fill p-smooth p-bigger" color="success" v-model="question.answer" :value="false" :name="`radio-${index}`">No</p-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vs-divider />
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button ref="submitBtn" class="vs-con-loading__container" type="filled" color="success" @click="submitAnswers">Submit</vs-button>
        </div>
        <div class="vx-col">
          <vs-button class="vs-con-loading__container" type="filled" color="warning" @click="closePrompt">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import uploaderSidebar from './StudentDocUploadSidebar.vue';

export default {
  components: {
    vSelect,
    uploaderSidebar
  },
  data() {
    return {
      uploadedFiles: [],
      sidebarActive: false,
      studentId: null,
      acceptPrompt: false,
      assessmentQuestions: [],
      answerData: {
        studentDocumentId: null,
        answers: []
      }
    }
  },
  watch: {
    acceptPrompt: function(val) {
      if (!val) {
        this.assessmentQuestions = [];
      }
    }
  },
  methods: {
    getDocuments() {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");

      var onSuccess = function (response) {
        self.uploadedFiles = response.data.map((item) => { return { id: item.id, url: item.url, accepted: item.accepted, moduleName: item.moduleName, documentTypeName: item.documentTypeName, documentTypeId: item.documentTypeId } });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      self.$ajaxGet(self, "Student/GetDocs", onSuccess, onFinally);
    },
    open(file) {
      window.open(file.url);
    },
    successUpload(data) {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");
      self.sidebarActive = false;
      var fileUrl = data.uploadedFileName;

      var onSuccess = response => {
        self.uploadedFiles.push({
          id: response.data.docId,
          url: fileUrl,
          moduleName: response.data.moduleName
        });
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Uploaded",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };

      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      var formData = {
        studentId: self.studentId,
        documentTypeId: data.documentTypeId,
        moduleId: data.moduleId,
        url: fileUrl
      }
      
      self.$ajaxPost(self, "Student/AddDoc", formData, onSuccess, onFinally);
    },
    getAssessmentQuestions() {
      var self = this;
      self.showLoadingOnElement("userDocsTab", 1, "corners");

      var onSuccess = function(response) {
        self.assessmentQuestions = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.userDocsTab.$el);
      };

      self.$ajaxGet(self, "AssessmentQuestion/GetAllQuestions", onSuccess, onFinally);
    },
    accept(id) {
      var self = this;
      self.getAssessmentQuestions();
      self.answerData.studentDocumentId = id;
      self.acceptPrompt = true;
    },
    reject(id) {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");

      var onSuccess = function(response) {
        self.getDocuments();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      //self.$ajaxGet(self, "Student/RejectDoc/" + id, onSuccess, onFinally);
    },
    removeDoc(id) {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");

      var onSuccess = function(response) {
        self.getDocuments();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      self.$ajaxGet(self, "Student/RemoveDoc/" + id, onSuccess, onFinally);
    },
    setFileThumb(url) {
      var ext = url.substring(url.lastIndexOf('.') + 1);
      if (ext.includes('mp3'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
      else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
      else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
      else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    cancelAdd() {
      this.$emit("cancelAdd")
    },
    submitAnswers() {
      var self = this;
      self.answerData.answers = self.assessmentQuestions.map(function(item) { return { assessmentQuestionId: item.id, answer: item.answer } });

      if (self.answerData.answers.filter(function(item) {return item.answer == null}).length > 0) {
        self.$vs.notify({
          title:'Information',
          color: "warning",
          text: "Please select an answer for all of the questions.",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-edit',
          time: 6000
        });
      } else {
        self.showLoadingOnElement("submitBtn", 0.45, "material");

        var onSuccess = function(response) {
          self.closePrompt();
          self.getDocuments();
          self.$vs.notify({
            title:'Information',
            color: "primary",
            text: "Feedback Submitted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.submitBtn.$el);
        };

        self.$ajaxPost(self, "AssessmentQuestion/SubmitAnswers", self.answerData, onSuccess, onFinally);
      }
    },
    closePrompt () {
      this.$vs.loading.close(this.$refs.submitBtn.$el);
      this.acceptPrompt = false;
    }
  },
  mounted() {
    var self = this;
    self.getDocuments();
    self.studentId = localStorage.getItem("Current_User_Id");
  }
}
</script>
<style lang="scss">
  #feedbackprompt.con-vs-dialog .vs-dialog {
    max-width: 500px !important;
  }
</style>
